

<div class="container-fluid">
  <div class="row">
    <div class="col-9 scout-pt-title-cell" [ngStyle]="{'background-color': pt.color}">
      {{ pt.name }}
    </div>
    <div class="col-3 scout-pt-type-cell">
      {{ pt.type }}
    </div>
  </div>
</div>
 
<table class="table table-striped table-condensed table-sm scout-point-props-table">
  <tr><th>Latitude</th><td>{{strLat}}</td></tr>
  <tr><th>Longitude</th><td>{{strLng}}</td></tr>
  <tr *ngIf="pt.type=='HA'&&pt.pointId">
    <th>Details</th>
    <td>
      <a href="javascript:false;" (click)="onShowPoint(pt.pointId)">
        Point
      </a>
    </td>
  </tr>
  <tr><th>External</th>
    <td>
      <a href="javascript:false;" (click)="onShowGoogleMapsPoint(strLat,strLng)">Google Maps</a>
    </td>
  </tr>
</table>

<div class="footer pt-sm-1">
  <button *ngIf="setSelectedPointFn && bShowSelectButton" class="btn btn-secondary btn-sm" (click)="changeGuard(selectedPt, onSelectPoint)">Select</button>
  <button *ngIf="showRefDataFn&&pt.type!='VIA'" class="btn btn-secondary btn-sm" (click)="onShowRefData()">Scout Ref</button>
</div>